(() => {
  angular
    .module('gm.common.services')
    .factory('GmyUserView', GmyUserView);

  function GmyUserView(
    gmyAcl,
    btgUser,
    GmyProfile
  ) {
    'ngInject';

    return {
      getProfile,
      isAuthenticated,
      isBusinessAccount,
      isFinishedSignup,
      isPersonalAccount,
      isProfileVerified,
    };

    function getProfile() {
      return btgUser.getProfile();
    }

    function isAuthenticated() {
      return btgUser.isAuthenticated();
    }

    function isBusinessAccount() {
      return btgUser.isAuthenticated()
        ? btgUser.getProfile().accountType === GmyProfile.PROFILE_TYPES.BUSINESS
        : false;
    }

    function isFinishedSignup() {
      const profile = btgUser.getProfile();

      return gmyAcl.isSignUpFinished(profile);
    }

    function isPersonalAccount() {
      return btgUser.isAuthenticated()
        ? btgUser.getProfile().accountType === GmyProfile.PROFILE_TYPES.PERSONAL
        : false;
    }

    function isProfileVerified() {
      const profile = btgUser.getProfile();

      return !!profile && profile.profileVerified;
    }
  }
})();
